import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output, SimpleChanges,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { DatePipe } from '@angular/common';
import {HttpResponse} from '@angular/common/http';
import {MultiSelectComponent} from '@progress/kendo-angular-dropdowns';
import {IDashboardCustomer, IDashboardFilter, ILocalLevel} from './filter.model';
import {ExcelExportData} from '@progress/kendo-angular-excel-export';
import {FilterService} from './filter.service';
import {ISerialNumber} from './serialnumber.model';
import {forkJoin, Observable, of} from 'rxjs';
import {IProductLine} from 'src/app/configuration/product/lines/productlines.model';
import {IArea} from 'src/app/models/area.model';
import {ICountry} from 'src/app/models/country.model';
import {CompositeFilterDescriptor, FilterDescriptor, process, State} from '@progress/kendo-data-query';
import {ExcelExportEvent, PagerSettings, PageSizeItem, ScrollMode} from '@progress/kendo-angular-grid';
import {IProductAlgorithm} from 'src/app/models/algorithm.model';
import {encodeBase64, saveAs} from '@progress/kendo-file-saver';

import {IDashboard} from '../dashboard/dashboard.model';
import {ICountryLocalLevel} from 'src/app/configuration/system/exclusions/exclusion.model';
import {IAppGridSetting, IColumnSetting, IExcelGridSettings} from 'src/app/shared/components/appgrid/appgrid.component';
import {MessageHandlerService, MessageItem, MessageTypes} from 'src/app/services/message-handler.service';
import * as moment from 'moment-timezone';

declare var bootstrap: any; // Bootstrap 5 modal API

@Component({
    selector: 'dashboard-filter',
    templateUrl: 'filter.component.html',
    styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit, OnDestroy, AfterViewInit  {

    reloadData = new EventEmitter<any>();

    @Input('open') open: boolean;
    @Input('filter') filter: IDashboardFilter;
    @Output('filterChanged') filterChanged = new EventEmitter<IDashboardFilter>();
    @Output('close') closeEvent = new EventEmitter();


    @ViewChild('modalRef') modalElement!: ElementRef;
    private modalInstance: any;


    @ViewChild('customersMultiSelect') customersMultiSelect: MultiSelectComponent;
    @ViewChild('serialNumbersMultiSelect') serialNumbersMultiSelect: MultiSelectComponent;
    // @ViewChild(GridComponent)

    @ViewChild('container', { read: ViewContainerRef })
    public containerRef: ViewContainerRef;

    public notificationChartData:Observable<any[]>;
    refreshIntervalId: any;

    public labelContent(e: any): string {
        return e.category;
    }

    // grid releated params
    public isFieldsOpen = false; //fields dropdown state
    public isExportOpen = false; //Export dropdown state

    notificationDataSize: number = 0;
    totalCountAvailable: number = 0;

    public autoRefreshMode = false; //The maintain switch state

    public allColumnsVisible: boolean = true;

    //public gridSettings!: IAppGridSetting; //Grid Settings
    public gridExcelSettings!: IExcelGridSettings; //Excel Grid Settings

    /**
     * RegExp to test a string for a ISO 8601 Date spec
     *  YYYY-MM-DD
     */
    private YYYY_MM_DD = /^\d{4}-\d{2}-\d{2}$/;

    /**
     * RegExp to test a string for a full ISO 8601 Date
     * Does not do any sort of date validation, only checks if the string is according to the ISO 8601 spec.
     *  YYYY-MM-DDThh:mm:ss
     *  YYYY-MM-DDThh:mm:ssTZD
     *  YYYY-MM-DDThh:mm:ss.sTZD
     * @see: https://www.w3.org/TR/NOTE-datetime
     * @type {RegExp}
     */
    private ISO_8601_FULL = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i

    //private static regexIso8601 = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{0,5})$/;
    //private static regexIso8601Date = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6})$/;

    public isCheckboxDisabled:boolean = false;

    public openRemoveDialog = false; //Determines if the remove dialog window should be open
    public deletingIcon = ''; //deleting icon for the delete dialog window
    public gridDataUrl!: string; //The grid data url
    dataRecord: any = {};

    enableAcknowledgeFields:boolean = true;
    ticketNumber:string = '';
    ticketNotes:string = '';
    ticketClosedDate: Date;
    maxTicketClosingDate = new Date();

    autoRefreshOnMessage: MessageItem[] = [{
        Type: MessageTypes.Info,
        Message: "Data Auto refresh happens every 15 mins",
        Timeout: 3000
    }];

    autoRefreshOffMessage: MessageItem[] = [{
        Type: MessageTypes.Info,
        Message: "Auto refresh turned off",
        Timeout: 3000
    }];


    //the state of the data in the grid
    //contains:
    //items to take
    //items to skip
    //sort options
    //filter options
    public state: State = {
        skip: 0,
        take: 20,
        filter: { logic: 'and', filters: [] }
    };

    public hiddenColumns: string[] = [ //Array containing the field names of the columns to hide
        'jobRunDate',
        'area',
        'seasCheckAuditSummary',
        'torCheckAuditSummary',
        'exclusionAuditSummary',
        'serviceContractOverrideReason',
        'ticketNotificationDate',
        'ticketDueDate',
        'emailNotificationDate',
        'oneViewNotificationDate',
        'processId',
        'createdBy',
        'createdDate',
        'modifiedBy',
        'modifiedDate'
    ];

    // public hiddenColumns: string[] = [];

    defaultFilters: IDashboardFilter;
    activeFilters: IDashboardFilter;

    minimizeNtfnSummary: boolean = false;
    minimizeNtfnData: boolean = false;

    //Form Data
    //User Orgs
    userOrgs: any; // Changed from `any[]` to `any` to allow object property access without TypeScript error
    userAreas: IArea[] = [];
    userCountries: ICountry[] = [];
    userCountryAreas: IArea[] = [];

    worldWide: boolean = false;

    //Locations
    areas: IArea[];
    selectedAreas: IArea[];
    allCountries: ICountry[] = [];
    areaFilteredCountries: ICountry[] = [];
    selectedCountries: ICountry[] = [];

    //Local Levels
    allLocalLevels: ICountryLocalLevel[] = [];
    filteredLocalLevels: ICountryLocalLevel[] = [];
    selectedLocalLevels: ICountryLocalLevel[] = [];

    //Customer
    customers: IDashboardCustomer[] = [];
    selectedCustomers: IDashboardCustomer[];
    customerFilter = '';

    //Product
    productLines: IProductLine[] = [];
    selectedProductLine: any;
    serialNumbers: ISerialNumber[] = [];
    selectedSerialNumbers: ISerialNumber[] = [];
    serialNumbersFilter = '';

    //Algorithms
    algorithmIndicatorsMap: any[] = [];
    algorithms: IProductAlgorithm[] = [];
    selectedAlgorithms: IProductAlgorithm[];

    // Algorithm Indicators
    algorithmIndicators: IProductAlgorithm[] = [];
    selectedAlgorithmIndicators: IProductAlgorithm[] = [];
    filteredAlgorithmIndicators: IProductAlgorithm[] = [];

    //Suppressions
    suppression: any[];

    //Ticket Type
    ticketType: any[];

    //Notifications
    notification: any[];

    // dates
    minDate: Date;
    startDate: Date;
    endDate: Date;

    dashboardData: IDashboard;
    public gridData: Observable<any[]>;
    // public form: FormGroup;
    public opened = false;

    public gridSettings: IAppGridSetting = {
        idField: "ntfnHistoryId",
        exportFileName: "DashboardData",
        newButtonText: "",
        showEnableDisable: false,
        showNew: false,
        showRemove: false,
        showEdit: false,
        serverSide: false,
        pageSize: 50,
        defaultSort: [
            {
                dir: "desc",
                field: "notificationProcessedDate"
            }
        ],
        columnSettings: [
          {
            title: "SN",
            field: "sn",
            filter: "text",
            width: 100
          },
          {
            title: "Product Line",
            field: "productLine",
            filter: "text",
            width: 100
          },
          {
            title: "Job Run Date",
            field: "jobRunDate",
            filter: "date",
            width: 100
          },
          {
            title: "Notification Processed Date",
            field: "notificationProcessedDate",
            filter: "date",
            width: 100
          },
          {
            title: "Flagged Date",
            field: "flaggedDate",
            filter: "date",
            width: 100
          },
          {
            title: "Customer Name",
            field: "customerName",
            filter: "text",
            width: 150
          },
          {
            title: "Customer Number",
            field: "customerNumber",
            filter: "text",
            width: 100
          },
          {
            title: "Area",
            field: "area",
            filter: "text",
            width: 100
          },
          {
            title: "Country",
            field: "country",
            filter: "text",
            width: 100
          },
          {
            title: "Local Level1",
            field: "localLevel1",
            filter: "text",
            width: 100
          },
          {
            title: "Local Level2",
            field: "localLevel2",
            filter: "text",
            width: 100
          },
          {
            title: "Primary FSR",
            field: "primaryFSR",
            filter: "text",
            width: 100
          },
          {
            title: "Algorithm",
            field: "algorithm",
            filter: "text",
            width: 150
          },
          {
            title: "Algorithm Indicator",
            field: "algorithmIndicator",
            filter: "text",
            width: 150
          },
          {
            title: "Experience Code",
            field: "experienceCode",
            filter: "text",
            width: 100
          },
          {
            title: "Experience Code Desc",
            field: "experienceCodeDesc",
            filter: "text",
            width: 150
          },
          {
            title: "Suppression Check",
            field: "suppressionCheck",
            filter: "boolean",
            width: 100
          },
          {
            title: "Suppression Audit Summary",
            field: "suppressionAuditSummary",
            filter: "text",
            width: 150
          },
          {
            title: "SEAS Check Passed",
            field: "seasCheckPassed",
            filter: "boolean",
            width: 100
          },
          {
            title: "SEAS Check Audit Summary",
            field: "seasCheckAuditSummary",
            filter: "text",
            width: 150
          },
          {
            title: "TOR Check Passed",
            field: "torCheckPassed",
            filter: "boolean",
            width: 100
          },
          {
            title: "TOR Check Audit Summary",
            field: "torCheckAuditSummary",
            filter: "text",
            width: 150
          },
          {
            title: "Is Excluded",
            field: "isExcluded",
            filter: "boolean",
            width: 100
          },
          {
            title: "Exclusion Audit Summary",
            field: "exclusionAuditSummary",
            filter: "text",
            width: 150
          },
          {
            title: "Ticket Validation Passed",
            field: "ticketValidationPassed",
            filter: "boolean",
            width: 100
          },
          {
            title: "Ticket Validation Audit Summary",
            field: "ticketValidationAuditSummary",
            filter: "text",
            width: 150
          },
          {
            title: "Has Service Contract Override",
            field: "hasServiceContractOverride",
            filter: "boolean",
            width: 100
          },
          {
            title: "Service Contract Override Reason",
            field: "serviceContractOverrideReason",
            filter: "text",
            width: 150
          },
          {
            title: "Has Service Contract",
            field: "hasServiceContract",
            filter: "boolean",
            width: 100
          },
          {
            title: "Service Contract Audit Summary",
            field: "serviceContractAuditSummary",
            filter: "text",
            width: 150
          },
          {
            title: "Overall Notification Enabled",
            field: "overallNotificationEnabled",
            filter: "boolean",
            width: 100
          },
          {
            title: "Notification Audit Summary",
            field: "notificationAuditSummary",
            filter: "text",
            width: 150
          },
          {
            title: "Ticket Notification Enabled",
            field: "ticketNotificationEnabled",
            filter: "boolean",
            width: 100
          },
          {
            title: "Ticket Created",
            field: "ticketCreated",
            filter: "boolean",
            width: 100
          },
          {
            title: "Ticket Number",
            field: "ticketNumber",
            filter: "text",
            width: 100
          },
          {
            title: "Ticket Owner",
            field: "ticketOwner",
            filter: "text",
            width: 150
          },
          {
            title: "Ticket Notification Date",
            field: "ticketNotificationDate",
            filter: "date",
            width: 100
          },
          {
            title: "Ticket Due Date",
            field: "ticketDueDate",
            filter: "date",
            width: 100
          },
          {
            title: "Ticket Notification Exception",
            field: "ticketNotificationException",
            filter: "text",
            width: 150
          },
          {
            title: "ONeview Notification Enabled",
            field: "oneViewNotificationEnabled",
            filter: "boolean",
            width: 100
          },
          {
            title: "ONeview Alert(s) Sent",
            field: "oneViewAlertsSent",
            filter: "boolean",
            width: 100
          },
          {
            title: "ONeview Notification Recipients",
            field: "oneViewNotificationRecipients",
            filter: "text",
            width: 150
          },
          {
            title: "ONeview Notification Date",
            field: "oneViewNotificationDate",
            filter: "date",
            width: 100
          },
          {
            title: "ONeview Notification Exception",
            field: "oneViewNotificationException",
            filter: "text",
            width: 150
          },
          {
            title: "Email Notification Enabled",
            field: "emailNotificationEnabled",
            filter: "boolean",
            width: 100
          },
          {
            title: "Email(s) Sent",
            field: "emailAlertsSent",
            filter: "boolean",
            width: 100
          },
          {
            title: "Email Notification Recipients",
            field: "emailNotificationRecipients",
            filter: "text",
            width: 150
          },
          {
            title: "Email Notification Date",
            field: "emailNotificationDate",
            filter: "date",
            width: 100
          },
          {
            title: "Email Notification Exception",
            field: "emailNotificationException",
            filter: "text",
            width: 150
          },
          {
            title: "Process ID",
            field: "processId",
            filter: "text",
            width: 100
          }
        ]
    };


    public static copyFilters(original: IDashboardFilter): IDashboardFilter {
        return (original) && <IDashboardFilter>JSON.parse(JSON.stringify(original));
    }

    public onExcelExport(e: ExcelExportEvent): void {
        const rows = e.workbook.sheets[0].rows;
      // align multi header
        rows[0].cells[2].hAlign = "center";

        // set alternating row color
        let altIdx = 0;
        rows.forEach((row:any) => {
          if (row.type === "data") {
            if (altIdx % 2 !== 0) {
              row.cells.forEach((cell:any) => {
                cell.background = "#aabbcc";
              });
            }
            altIdx++;
          }
        });
      }

    public form: FormGroup;

    public fullFormat = "yyyy-MM-dd";
    public fullFormatHHMMSS = "yyyy-MM-dd  HH:mm:ss";

    constructor(private _filterService: FilterService, public fb: FormBuilder
        , private _msgService: MessageHandlerService, private cd: ChangeDetectorRef, private datePipe: DatePipe) {
        this.saveExcel = this.saveExcel.bind(this);
    }

    onTabSelect(event: any): void {
        //console.log(event);
    }

    public toggleText = "Hide";
    public show = false;

    public onToggle(): void {
        this.show = !this.show;
        this.toggleText = this.show ? "Hidе" : "Show";
      }

      private isIE10(): boolean {
        return /MSIE 10/i.test(navigator.userAgent);
    }

    private isIE11(): boolean {
        return /rv:11.0/i.test(navigator.userAgent);
    }

    public getHeight(): number {

        if (this.isIE10()) {
            // This is internet explorer 10
            return -1;
        }

        if ( this.isIE11()) {
            // This is internet explorer 9 or 11
            return 9999;
        }

        return -1;
    }

    public getMaxHeight(): string {
        if(this.isIE10()) {
            return '-1px';
        }

        let userWindowHeight = window.screen.availHeight;

        if (userWindowHeight - 200 < 300) {
            return 300 + 'px';
        } else {
            return (userWindowHeight - 250) + 'px';
        }
    }

    public flaggedChartData: Observable<any[]>;
    public snCountsByAlgChartData: any[];
    public algorithmChartCategories: any[];
    // public chartCategories: any = [] ;
    public flaggedCount: any = 0;
    public notificationCount: any = 0;
    public suppressedCount: any = 0;
    public chartOptions: any;

    //Display flags
    public displayAreas: string[] = [];
    public displayCountries: string[] = [];
    public displayLocalLevels: string[] = [];
    public displayCustomers: string[] = [];
    public displayProductLine: string;
    public displaySerialNumbers: string[] = [];
    public displayAlgorithms: string[] = [];
    public displayAlgorithmIndicators: string[] = [];
    public displaySuppression: string[] = [];
    public displayNotifications: string[] = [];
    public displayTicketType: string[] = [];

    private ticketTypes: string[] = [
      'Service Demand', 'Service Planned'
    ];

    private notifications: string[] = [
      'Ticket Enabled', 'Ticket Created', 'Email Enabled', 'Email Created', 'ONeview Alert Enabled', 'ONeview Alert Created'
    ];

    private suppressions: string[] = [
      'SEAS', 'TOR', 'Excluded', 'Ticket Validation', 'Service Contract'
    ];

    getTicketTypes(): Observable<string[]> {
      return of(this.ticketTypes);
    }

    getNotifications(): Observable<string[]> {
      return of(this.notifications);
    }

    getSuppressions(): Observable<string[]> {
      return of(this.suppressions);
    }

    public disabledDates = (date: Date): boolean => {
        const today = (d => new Date(d.setDate(d.getDate())))(new Date);
        return (date.getTime() > today.getTime());
    };

    
  ngAfterViewInit() {
    this.modalInstance = new bootstrap.Modal(this.modalElement.nativeElement, {
      backdrop: 'static', // Optional: prevents closing on outside click
      keyboard: true
    });
  }
  
  openModal() {
    this.modalInstance.show();
  }

  closeModal() {
    this.modalInstance.hide();
  }


    ngOnDestroy() {
        if (this.refreshIntervalId) {
            clearInterval(this.refreshIntervalId);
        }
    }

    ngOnInit() {

        //this.loadGridSettings();
        this.processGridSettings();

        // Set the initial state of allColumnsVisible
        this.allColumnsVisible = this.hiddenColumns.length === 0;

        this.minDate = (d => new Date(d.setDate(d.getDate() - 366)))(new Date);
        this.startDate = (d => new Date(d.setDate(d.getDate() - 7)))(new Date);
        this.endDate = new Date();

        this.form = new FormGroup({
            areas: new FormControl(),
            countries: new FormControl(),
            localLevels: new FormControl(),
            customers: new FormControl(),
            productLine: new FormControl(),
            suppression: new FormControl(),
            ticketType: new FormControl(),
            notification: new FormControl(),
            serialNumbers: new FormControl(),
            algorithms: new FormControl(),
            algorithmIndicators: new FormControl(),
            startDate: new FormControl(this.startDate),
            endDate: new FormControl(this.endDate),
        });


        this._filterService.getUserAreaCountries().subscribe((data:any)=> {
            this.userOrgs = data;
            //console.log('user orgs 1st call: ', data);
            this.worldWide = data.worldWide || false;
            if (this.worldWide !== true) {
                this.userAreas = this.userOrgs['areas'];
                this.userCountries = this.userOrgs['userAssignedCountries'];
                this.userCountryAreas = this.userOrgs['countryAreas'];
            }
            //console.log("userAreas: ", this.userAreas);
            //console.log("userCountries: ", this.userCountries);
            //console.log("userCountryAreas: ", this.userCountries);

            // Added optional chaining(?.) to safely access forEach metchod and to prevent potential rutime errors
            this.userCountryAreas?.forEach((element: IArea) => {
                this.displayAreas.push(element.area);
            });

            this.userCountries?.forEach((element: ICountry) => {
                this.displayCountries.push(element.country);
            });


            this.fetchDashboardData();
        });
    }

    fetchDashboardData() {
        // console.log("User orgs from fetch method: ", this.userOrgs);

        const userAreaIds = this.userCountryAreas?.map(function (obj) { return parseInt(obj.id); });
        const userCountryCodes = this.userCountries?.map(function (obj) { return obj.countryCode; });

         //Build our starting filter
        this.filter = {
            worldWide: false,
            areaIds: userAreaIds,
            countryCodes: userCountryCodes,
            localLevels: [],
            customerNumbers: [],
            pl: null,
            sns: [],
            algorithmIds: [],
            algorithmIndicatorIds: [],
            suppression: [],
            ticketType: [],
            notification: [],
            startDate: this.convertToUTC(this.startDate).split('T')[0],
            endDate: this.convertToUTC(this.endDate).split('T')[0]
        };

        this.defaultFilters = FilterComponent.copyFilters(this.filter);
        // console.log('Default filters: ', this.defaultFilters);

        forkJoin([
            this._filterService.getAreas(),
            this._filterService.getCountries(),
            this._filterService.getLocalLevels(),
            this.getSuppressions(),
            this._filterService.getProductLines(),
            this._filterService.getAlgPLIndicators(),
            this.getTicketTypes(),
            this.getNotifications(),
            this._filterService.setDashboardData(this.defaultFilters)

        ]).subscribe(
            (data: any[]) => {
                this.areas = data[0];
                // sort area list
                this.areas = this.areas.sort((a,b) => a.area.localeCompare(b.area));

                this.allCountries = data[1];
                // sort country list
                this.allCountries = this.allCountries.sort((a,b) => a.country.localeCompare(b.country));
                this.areaFilteredCountries = this.allCountries;

                this.allLocalLevels = data[2];
                this.allLocalLevels.forEach(data => {
                    data.localLevel = data.localLevel2 ? data.localLevel1 + ' : ' + data.localLevel2 : data.localLevel1;
                });

                this.suppression = data[3];
                this.productLines = data[4];
                this.algorithmIndicatorsMap = data[5];
                this.ticketType = data[6];
                this.notification = data[7];
                this.dashboardData = data[8];
                this.notificationDataSize = data[8].notificationData.length;
                this.totalCountAvailable = data[8].totalRecords;

                this.buildForm();
                this.setupDashboardData();
            }
        );
    }

    buildForm() {
        this.selectedAreas = this.userCountryAreas;
        this.selectedCountries = this.userCountries;
        this.handleAreasSelectionChange(this.selectedAreas);
        this.handleCountriesChange(this.selectedCountries);

        this.form = this.fb.group({
            areas: [this.selectedAreas],
            countries: [this.selectedCountries],
            localLevels: new FormControl(),
            customers: new FormControl(),
            productLine: new FormControl(),
            suppression: new FormControl(),
            ticketType: new FormControl(),
            notification: new FormControl(),
            serialNumbers: new FormControl(),
            algorithms: new FormControl(),
            algorithmIndicators: new FormControl(),
            startDate: [this.startDate, [Validators.required]],
            endDate: [this.endDate, [Validators.required]]
        });

        this.setupAlgorithmsData();
    }

    setupAlgorithmsData() {
        this.algorithms = [];
        this.algorithmIndicators = [];
        for (let algo in this.algorithmIndicatorsMap) {
            this.algorithms.push(this.algorithmIndicatorsMap[algo][0]);
            this.algorithmIndicators.push(...this.algorithmIndicatorsMap[algo]);
        }
        this.algorithms = this.algorithms.sort((a,b) => a.algorithmName.localeCompare(b.algorithmName));
        this.algorithmIndicators = this.algorithmIndicators.sort((a, b) => a.algIndicatorName.localeCompare(b.algIndicatorName));

        //console.log(`Algorithms list: `, this.algorithms);
        //console.log(`Indicators list: `, this.algorithmIndicators);

        this.filteredAlgorithmIndicators = this.algorithmIndicators;
    }

    private convertDateStringsToDates(input: any[]): any[] {
        for (let row of input) {
            for (let key in row) {
                if (!row.hasOwnProperty(key)) {
                    continue;
                }

                let value = row[key];
                let match;
                // Check for string properties which look like dates.
                if (typeof value === 'string' && (match = value.match(this.ISO_8601_FULL))) {
                    row[key] = new Date(value.substring(0,16)+'Z');
                } else if (typeof value === 'string' && (match = value.match(this.YYYY_MM_DD))) {
                    row[key] = new Date(value.substring(0,10)+'Z');
                }
            }
        }

        return input;
    }

    setupDashboardData() {

        this.gridData = of(this.convertDatesToLocalTime(this.dashboardData.notificationData));
        for (let i = 0; i < this.dashboardData.algorithmFlaggedChartData.length ; i++) {
          let algNameIndicatorName = this.dashboardData.algorithmFlaggedChartData[i].algorithmName + "-" + this.dashboardData.algorithmFlaggedChartData[i].algIndicatorName;
          this.dashboardData.algorithmFlaggedChartData[i].algNameIndicatorName = algNameIndicatorName;
        }
        this.flaggedChartData = of(this.dashboardData.algorithmFlaggedChartData);

        // this.snCountsByAlgChartData = this.dashboardData.algorithmSnChartData;
        // prepare algorithm chart data
        // const snCountsChartData: any[] = [];
        // if (this.snCountsByAlgChartData) {
        //     this.snCountsByAlgChartData.forEach((element:any) => {
        //         const key  = element.sn;
        //         const value  = element.algorithmFlaggedChartFieldsListBySn[0].flaggedCount;
        //         snCountsChartData.push({
        //             key,
        //             value
        //         })
        //     });
        // }
        // this.chartCategories = snCountsChartData;

        this.setSNAlgorithmChartData();

        this.flaggedCount = this.dashboardData.dashboardCounts.flaggedCount;
        this.notificationCount = this.dashboardData.dashboardCounts.notificationCount;
        this.suppressedCount = this.dashboardData.dashboardCounts.suppressedCount;
        this.notificationDataSize = this.dashboardData.notificationData.length;
        this.totalCountAvailable = this.dashboardData.totalRecords;
        // TODO - set chart data
    }

    setSNAlgorithmChartData() {
        // prepare the stack and grid label data from the response
        const gridLabels: string[] = [];
        var gridLabelAlgNames: { [key: string]: string } = {};

        for (let i = 0; i < this.dashboardData.algorithmSnChartData.length; i++) {
          for (let j = 0; j < this.dashboardData.algorithmSnChartData[i].algorithmFlaggedChartFieldsListBySn.length; j++) {
            this.dashboardData.algorithmSnChartData[i].algorithmFlaggedChartFieldsListBySn[j].algNameIndicatorName = this.dashboardData.algorithmSnChartData[i].algorithmFlaggedChartFieldsListBySn[j].algorithmName
              + "-" + this.dashboardData.algorithmSnChartData[i].algorithmFlaggedChartFieldsListBySn[j].algIndicatorName;
          }
        }

        this.snCountsByAlgChartData = this.dashboardData.algorithmSnChartData;

        this.snCountsByAlgChartData.forEach((element: any) => {
            let algFlaggedCounts: any[] = element.algorithmFlaggedChartFieldsListBySn;
            for (let alggedFlaggedData of algFlaggedCounts) {
                let algNameIndicatorName = alggedFlaggedData.algNameIndicatorName;
                if (!gridLabels.includes(algNameIndicatorName)) {
                    gridLabels.push(algNameIndicatorName);
                    gridLabelAlgNames[algNameIndicatorName] = alggedFlaggedData.algNameIndicatorName;
                }
            }
        });
        //console.log('snCountsByAlgChartData: ', this.snCountsByAlgChartData);
        //console.log('gridLabels: ', gridLabels);
        //console.log('gridLabelAlgNames: ', gridLabelAlgNames);

        const values: any[] = [];
        this.snCountsByAlgChartData.forEach((element: any) => {
            const dataRow: any = {};
            dataRow['xlabel'] = element.sn;
            dataRow['stacks'] = [];
            let algFlaggedChartSnFields: any[] = element.algorithmFlaggedChartFieldsListBySn;
            for (let gridLabel of gridLabels) {
                let flaggedCount = 0;
                for (let algFlaggedChartSnField of algFlaggedChartSnFields) {
                    if (algFlaggedChartSnField.algNameIndicatorName === gridLabel) {
                        flaggedCount = algFlaggedChartSnField.flaggedCount;
                        break;
                    }
                }
                dataRow['stacks'].push(flaggedCount);
            }
            values.push(dataRow);
        });
        //console.log('values: ', values);
        // prepare algorithm chart data

        const chartStackSeries: any[] = [];
        let stackPosition = 'axis';
        gridLabels.forEach((gridLabel, index) => {
            chartStackSeries.push({
                name: gridLabel.length > 25 ? gridLabel.substring(0, 25) : gridLabel,
                //color: chartBarColor,
                type: 'bar',
                //gap: .5,
                // border: {
                //     color: '#000',
                //     width: 1,
                //     dashType: 'solid'
                // },
                data: [] as any[],
                axis: stackPosition,
                labels: {
                    background: "",
                    font: "16px",
                    //format: '{0}',
                    // content: (index === gridLabels.length - 1) ? stackValue : '',
                    //position: (index === gridLabels.length) ? 'right' : 'insideEnd',
                    position: 'insideEnd',
                    template: function(data: any) {
                        //console.log("data:", data);
                        //console.log("index:", index);
                        //console.log('gridLabel:', gridLabel);
                        return  data.value ? data.value : '';
                    },
                    visible: true
                },
                //content: 50
                //,
                tooltip: {
                    visible: true,
                    background: '#aa0061',
                    padding: '2',
                    //format: gridLabelAlgNames[gridLabel] + ": " + gridLabel  + " - " + "{0}"
                    format:  gridLabel  + " - " + "{0}"
                }
            });
        });

        const chartCategories = [];
        let chartDataItemKey;
        for (const chartDataColumn of values) {
            chartCategories.push(chartDataColumn.xlabel);
            for (chartDataItemKey = 0; chartDataItemKey < chartDataColumn.stacks.length; chartDataItemKey++) {
                const chartDataItem = chartDataColumn.stacks[chartDataItemKey];
                const intValue = parseInt(chartDataItem);
                chartStackSeries[chartDataItemKey].data.push(intValue);
                // if (chartDataItemKey === chartDataColumn.stacks.length - 1) {
                //     chartStackSeries[chartDataItemKey].data.push(0);
                // }

            }
        }
        // Ref: to show sum totals: https://www.telerik.com/kendo-angular-ui/components/knowledge-base/chart-count-label-stacked-bar/
        // to show the sum totals, add an extra row at the end
        let emptyDataRow = [];
        for (let cht = 0; cht < chartCategories.length; cht++) {
            emptyDataRow.push(0);
        }
        chartStackSeries.push({
            data: emptyDataRow,
            axis: stackPosition,
            labels: {
                background: "",
                font: "16px",
                position: 'right',
                template: function(data: any) {
                    return data.stackValue;
                },
                visible: true
            }
        });

        const chartSeries = chartStackSeries;

        //console.log("chartCategories", chartCategories);
        //console.log("chartSeries", chartSeries);

        const valueAxis = {
            name: 'axis',
            labels: {
                format: '{0}',
                content: (e: any) => {
                    return e.value;
                },
                position: 'start',
                visible: true
            },
            //max: axis1Max,
            min: 0,
            //majorUnit: axis1Max / this.axis1LabelSegments,
            line: {
                visible: true
            },
            title: {
                text: "SN counts by Algorithm Indicator"
            }
            //,
            // tooltip: {
            //     visible: true,
            //     format: '{0}',
            //     background: '#aa0061',
            //     padding: '2'
            // }
        };

      this.chartOptions = {
        seriesDefaults: {
          type: 'bar',
          stack: true,
          gap: 0.8, // Adjust this to control space between categories
          spacing: 1.5// Adjust this to control space between bars in the same category
          // labels: {
          //     visible: true,
          //     template: "Total: #: value #"
          // }
        },
            series: chartSeries,
            chartArea: {
                // border: {
                //     color: '#000',
                //     width: 1,
                //     dashType: 'solid'
                // }
            },
            valueAxis: [valueAxis],
            categoryAxis: {
                categories: chartCategories,
                majorGridLines: {
                    visible: true
                },
                labels: {
                    // background: 'black',
                    // color: 'blue',
                    // padding: 5,
                    // content: (e: any) => {
                    //     return 'Sum:' + e.text;
                    // }
                    rotation: 0
                    //font: '12px bold'
                }
            }
          
        };


    }

    public totalLabelContent(args: any): string {
        //console.log('stack args', args);
        return args.stackValue;
    }


    resetFilters() {
        this.filter = FilterComponent.copyFilters(this.defaultFilters);
        this.startDate = (d => new Date(d.setDate(d.getDate() - 7)))(new Date);
        this.endDate = new Date();
        this.buildForm();

        this.displayAreas = [];
        this.displayCountries = [];
        this.displayLocalLevels = [];
        this.displayCustomers = [];
        this.displayProductLine = "";
        this.displaySerialNumbers = [];
        this.displayAlgorithms = [];
        this.displayAlgorithmIndicators = [];
        this.displaySuppression = [];
        this.displayTicketType = [];
        this.displayNotifications = [];

        this.userCountryAreas?.forEach((element: IArea) => {
            this.displayAreas.push(element.area);
        });

        this.userCountries?.forEach((element: ICountry) => {
            this.displayCountries.push(element.country);
        });

        this.refreshData()

    }

    private cleanQueryParams(query: any) {
        Object.keys(query).forEach(key => {
            if(query[key] instanceof Object && Object.keys(query[key]).length === 0){
                //console.log("VAL", query[key]);
            }

            if (query[key] === '' || query[key] === undefined || query[key] === null || query[key] === 'null') {
                delete query[key];
            }
        });
        return query;
    }

    //public onSubmit({ value }: { value: IDashboardFilter }) {
    public refreshData() {

        this.displayAreas = [];
        this.displayCountries = [];
        this.displayLocalLevels = [];
        this.displayCustomers = [];
        this.displayProductLine = "";
        this.displaySerialNumbers = [];
        this.displayAlgorithms = [];
        this.displayAlgorithmIndicators = [];
        this.displaySuppression = [];
        this.displayTicketType = [];
        this.displayNotifications = [];

        const areas: IArea[] = [];
        const parsedAreaIds: number[] = [];
        if (this.form.controls['areas'].value !== null) {
            this.form.controls['areas'].value.forEach((area: IArea) => {
                areas.push(area);
                parsedAreaIds.push(parseInt(area.id));
                this.displayAreas.push(area.area);
            });
            this.selectedAreas = areas;
        } else {
            this.selectedAreas = [];
        }

        const countries: ICountry[] = [];
        const parsedCountryCodes: string[] = [];
        if (this.form.controls['countries'].value !== null) {
            this.form.controls['countries'].value.forEach((country: ICountry) => {
                countries.push(country);
                parsedCountryCodes.push(country.countryCode);
                this.displayCountries.push(country.country);
            });
            this.selectedCountries = countries;
        } else {
            this.selectedCountries = [];
        }

        const localLevels: ICountryLocalLevel[] = [];
        const parsedLocalLevels: ILocalLevel[] = [];
        if (this.form.controls['localLevels'].value !== null) {
            this.form.controls['localLevels'].value.forEach((localLevel: ICountryLocalLevel) => {
                localLevels.push(localLevel);
                const parsedLocalLevel: ILocalLevel = {
                    localLevel1: localLevel.localLevel1,
                    localLevel2: localLevel.localLevel2
                };
                parsedLocalLevels.push(parsedLocalLevel);
                this.displayLocalLevels.push(localLevel.localLevel);
            });
            this.selectedLocalLevels = localLevels;
        } else {
            this.selectedLocalLevels = [];
        }

        const customers: IDashboardCustomer[] = [];
        const parsedCustomerNums: string[] = [];
        if (this.form.controls['customers'].value !== null) {
            this.form.controls['customers'].value.forEach((customer: IDashboardCustomer) => {
                customers.push(customer);
                parsedCustomerNums.push(customer.customerNum);
                this.displayCustomers.push(customer.customerDisplayString);
            });
            this.selectedCustomers = customers;
        } else {
            this.selectedCustomers = [];
        }

        let productLine: IProductLine = this.form.controls['productLine'].value;
        let parsedPl: string = null;
        if (productLine != null) {
            parsedPl = productLine.code;
            this.displayProductLine = productLine.name;
        }
        const serialNumbers: ISerialNumber[] = [];
        const parsedSerialNums: string[] = [];
        if (this.form.controls['serialNumbers'].value !== null) {
            this.form.controls['serialNumbers'].value.forEach((serialNumber: ISerialNumber) => {
                serialNumbers.push(serialNumber);
                parsedSerialNums.push(serialNumber.sn);
                this.displaySerialNumbers.push(serialNumber.sn);
            });
            this.selectedSerialNumbers = serialNumbers;
        } else {
            this.selectedSerialNumbers = [];
        }

        const algorithms: IProductAlgorithm[] = [];
        const parsedAlgorithmIds: number[] = [];
        if (this.form.controls['algorithms'].value !== null) {
            this.form.controls['algorithms'].value.forEach((algorithm: IProductAlgorithm) => {
                algorithms.push(algorithm);
                parsedAlgorithmIds.push(algorithm.algorithmId);
                this.displayAlgorithms.push(algorithm.algorithmName);
            });
            this.selectedAlgorithms = algorithms;
        } else {
            this.selectedAlgorithms = [];
        }

        const algIndicators: IProductAlgorithm[] = [];
        const parsedAlgIndicatorIds: number[] = [];
        if (this.form.controls['algorithmIndicators'].value !== null) {
            this.form.controls['algorithmIndicators'].value.forEach((algIndicator: IProductAlgorithm) => {
                algIndicators.push(algIndicator);
                parsedAlgIndicatorIds.push(algIndicator.algIndicatorId);
                this.displayAlgorithmIndicators.push(algIndicator.algIndicatorName);
            });
            this.selectedAlgorithmIndicators = algIndicators;
        } else {
            this.selectedAlgorithmIndicators = [];
        }

        const selectedSuppression = this.form.controls['suppression'].value;
        if (selectedSuppression !== null) {
          selectedSuppression.forEach((suppressionName: string) => {
            this.displaySuppression.push(suppressionName);
          });
        }

        const selectedTicketType = this.form.controls['ticketType'].value;
        if (selectedTicketType !== null) {
          selectedTicketType.forEach((ticketType: string) => {
            this.displayTicketType.push(ticketType);
          });
        }

        const selectedNotification = this.form.controls['notification'].value;
        if (selectedNotification !== null) {
          selectedNotification.forEach((notifications: string) => {
            this.displayNotifications.push(notifications);
          });
        }
        this.startDate =  this.form.controls['startDate'].value;
        this.endDate = this.form.controls['endDate'].value;

         //Build our starting filter
         this.filter = {
            worldWide: false,
            areaIds: parsedAreaIds,
            countryCodes: parsedCountryCodes,
            localLevels: parsedLocalLevels,
            customerNumbers: parsedCustomerNums,
            pl: parsedPl,
            sns: parsedSerialNums,
            algorithmIds: parsedAlgorithmIds,
            algorithmIndicatorIds: parsedAlgIndicatorIds,
            suppression: selectedSuppression,
            ticketType: selectedTicketType,
            notification: selectedNotification,
            startDate: this.convertToUTC(this.startDate).split('T')[0],
            endDate: this.convertToUTC(this.endDate).split('T')[0],
        };
        const filterPayload = this.cleanQueryParams(this.filter);
        //console.log(filterPayload);
        this.activeFilters = FilterComponent.copyFilters(filterPayload);
        //console.log(requestPayload);

        this._filterService.setDashboardData(this.activeFilters).subscribe(
            (data: any) => {
                this.dashboardData = data;
                this.notificationDataSize = data.length;
                this.totalCountAvailable = data.totalRecords;
                //this.gridData = of(data.notifications);
                this.setupDashboardData();
              // Delay the DOM access to the next JavaScript tick
              setTimeout(() => {
                this.closeModal();
                const myModalElement = document.getElementById("myModal");
                if (myModalElement) {
                  myModalElement.click();
                } else {
                  console.error('Element with ID "myModal" not found in the DOM');
                }
              }, 0);
            },
            error => this.serialNumbersMultiSelect.loading = false,
            () => this.serialNumbersMultiSelect.loading = false
        );
        // this.filter = FilterComponent.copyFilters(value);
        // this.filter.worldWide = this.filter.areas.length == 0 && this.filter.countries.length == 0;
        // this.filterChanged.emit(FilterComponent.copyFilters(this.filter));
    }

    downloadExcel() {
      const requestData = this.isValidFilter(this.activeFilters) ? this.activeFilters : this.defaultFilters;

      this._filterService.getExportAllFile(requestData).subscribe({
        next: (response: HttpResponse<Blob>) => {
          console.log('Response:', response);
          const contentType = 'text/csv';
          const blob = new Blob([response.body], { type: contentType });
          const contentDisposition = response.headers.get('Content-Disposition');
          let filename = 'exportall.csv';
          if (contentDisposition) {
            const filenameMatch = this.getFileNameFromContentDisposition(contentDisposition);
            if (filenameMatch) {
              filename = filenameMatch;
            }
          }
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.setAttribute('download', filename);
          a.click();
          window.URL.revokeObjectURL(url);
        },
        error: (err: any) => {
          console.error('Error:', err);
        }
      });
    }

    private getFileNameFromContentDisposition(contentDisposition: string): string | null {
      const result = contentDisposition.split(';').find(part => part.trim().startsWith('filename='));
      if (result) {
        let filename = result.split('=')[1].trim();
        if (filename.startsWith('"') && filename.endsWith('"')) {
          filename = filename.substring(1, filename.length - 1);
        }
        return filename;
      }
      return null;
    }

    private isValidFilter(filter: IDashboardFilter): boolean {
      return filter != null && filter.startDate != null && filter.endDate != null;
    }

    // Method to convert all date fields in the dataset to local time
    convertDatesToLocalTime(data: any[]): any[] {
      return data.map(item => {
        return {
          ...item,
          flaggedDate: this.convertToLocalDateObject(item.flaggedDate),
        };
      });
    }

    convertToLocalDateObject(utcDate: string): Date | null {
      if (!utcDate) {
        return null;
      }
      const localDate = new Date(utcDate);
      return isNaN(localDate.getTime()) ? null : localDate;
    }

    convertToUTC(date: Date): string {
      // Convert local date to UTC string
      return date.toISOString();
    }

    getUserTimeZone(): string {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

  handleAreasSelectionChange(areas: IArea[]) {
    this.selectedAreas = areas;

    if (areas && areas.length != 0) {
      // Filter countries based on selected areas
      this.areaFilteredCountries = this.allCountries.filter(c => areas.some(a => a.id === c.area.id));

      if (this.form) {
        // Handle countries form control
        const selectedCountries = this.form.get('countries').value || [];
        const updatedCountries = selectedCountries.filter((c: ICountry) => this.selectedAreas.some(a => a.id === c.area.id));
        this.form.get('countries').setValue(updatedCountries);

        // Handle local levels form control
        const selectedCountryCodes = new Set(updatedCountries.map((c: ICountry) => c.countryCode));
        const currentLocalLevels = this.form.get('localLevels').value || [];
        const updatedLocalLevels = currentLocalLevels.filter((l: any) => selectedCountryCodes.has(l.countryCode));
        this.form.get('localLevels').setValue(updatedLocalLevels);

        // Update filtered local levels based on selected countries
        this.filteredLocalLevels = this.allLocalLevels.filter((l: any) => selectedCountryCodes.has(l.countryCode));
      }
    } else {
      // Clear countries and local levels if no areas are selected
      this.areaFilteredCountries = this.allCountries;
      if (this.form) {
        this.form.get('countries').setValue([]);
        this.form.get('localLevels').setValue([]);
      }
      this.filteredLocalLevels = [];
    }


  }

  handleCountriesChange(countries: ICountry[]) {
    this.selectedCountries = countries;

    if (countries && countries.length >= 1) {
      // Filter local levels based on selected countries
      this.filteredLocalLevels = this.allLocalLevels.filter(l => countries.some(c => c.countryCode == l.countryCode));
    } else {
      // Clear local levels if no countries are selected
      this.filteredLocalLevels = [];
    }

    // Clear local levels for unselected countries
    const selectedCountryCodes = new Set(countries?.map(c => c.countryCode));
    this.filteredLocalLevels = this.filteredLocalLevels?.filter(l => selectedCountryCodes.has(l.countryCode));

    // Update the form control for local levels
    if (this.form) {
      const currentLocalLevels = this.form.get('localLevels').value;
      const updatedLocalLevels = currentLocalLevels?.filter((l: any) => selectedCountryCodes.has(l.countryCode));
      this.form.get('localLevels').setValue(updatedLocalLevels);
    }
  }

    handleCustomersFilter(filter: string) {
        this.customerFilter = filter;
        if (filter && filter.length >= 4) {
            this.customersMultiSelect.loading = true;
            this._filterService.getCustomers(filter)
            .subscribe(
                (data: any) => {
                    //console.log('customer search results: ', filter, data);
                    this.customers = data['customerSearchDataList'];
                },
                error => this.customersMultiSelect.loading = false,
                () => this.customersMultiSelect.loading = false
            );
        }
    }

    handleProductLineChange(product: IProductLine) {
        this.selectedProductLine = product ? product : null;
        if (this.selectedProductLine != null) {
            this.serialNumbers = [];
            this.form.get('serialNumbers').setValue([]);
        }
    }

    handleSerialNumbersFilter(filter: string) {
        this.serialNumbersFilter = filter;
        let code = this.selectedProductLine ? this.selectedProductLine.code : null;
        if (filter && filter.length >= 3) {
            this.serialNumbersMultiSelect.loading = true;
            this._filterService.getSerialNumbers(filter, code)
            .subscribe(
                (data: any) => {
                    this.serialNumbers = data['snSearchDataList']
                },
                error => this.serialNumbersMultiSelect.loading = false,
                () => this.serialNumbersMultiSelect.loading = false
            );
        }
    }

    handleAlgorithmsChange(algorithms: IProductAlgorithm[]) {
        //console.log('algorithm changed event: ', algorithms);
        this.selectedAlgorithms = algorithms;
        if(algorithms && algorithms.length != 0) {
            this.filteredAlgorithmIndicators = this.algorithmIndicators.filter(pdm => algorithms.findIndex((m: { algorithmId: any; }) => m.algorithmId == pdm.algorithmId) != -1);
            if (this.form && this.form.get('algorithmIndicators').value !== null) {
                this.form.get('algorithmIndicators').setValue(this.form.get('algorithmIndicators').value.filter(
                    (c: IProductAlgorithm) => this.selectedAlgorithms.findIndex(a => a.algorithmId == c.algorithmId) != -1));
            }
        } else {
            this.filteredAlgorithmIndicators = this.algorithmIndicators;
        }

    }


    //A Click outside a dropdown occurred
    public onClickOutside(id: number, event: any) {
        if (event && event['value'] === true) {
            if (id === 0) {
                this.isFieldsOpen = false;
            } else if (id === 1) {
                this.isExportOpen = false;
            }
        }
    }

    private processGridSettings() {

        //Setup Pager Settings
        this.gridSettings.pageable = {
            buttonCount: 10,
            info: true,
            pageSizes: [5, 10, 20, 50, 100, 250, 500],
            previousNext: true
        };

        this.isCheckboxDisabled = this.hiddenColumns.length < 1 ? true : false;

        //Build the hidden columns with the defaults and the ones in the grid settings
        if (this.gridSettings.hiddenColumns != null) {
            this.hiddenColumns = this.hiddenColumns.concat(this.gridSettings.hiddenColumns);
        }

        //Set Scroll Settings
        this.state.sort = this.gridSettings.defaultSort;
        this.state.take = this.gridSettings.pageSize ? this.gridSettings.pageSize : 50;

        //Configure the grid based on if we're in dashboard mode or not
        if(this.gridSettings.dashboardMode == null) {
            this.gridSettings.dashboardMode = false;
            this.gridSettings.scrollable = 'scrollable';
            this.gridSettings.sortable = { 'mode': 'multiple' };
        } else {
            this.gridSettings.pageable = false;
            this.gridSettings.scrollable = 'none';
            this.gridSettings.sortable = false;
        }

        //Set Export Settings
        let date = new Date();
        this.gridSettings.exportFileName = `${this.gridSettings.exportFileName}-${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

    }

    //Return the format for the given column
    public getFormat(column: IColumnSetting): string {
        if (column.format) {
            //We have a set column format so use that
            return column.format;
        } else if (column.filter === 'date') {
            //Use our audit date format
            return '{0:yyyy-MM-dd HH:mm}';
        }

        //Return an empty string
        return '';
    }

    public isPageable(prop: string): boolean {
        const pageable = this.gridSettings?.pageable as PagerSettings;
        switch(prop) {
            case 'previousNext':
                return pageable.previousNext !== null;
            case 'info':
                return pageable.info !== null;
        }
        return false;
    }

    public get pageable(): PagerSettings {
        return this.gridSettings.pageable as PagerSettings;
    }

    public get pageablePageSizes(): (number | PageSizeItem)[] {
        return this.pageable.pageSizes as (number | PageSizeItem)[];
    }

    public get pageableButtonCount(): number {
        return this.pageable.buttonCount as number;
    }

    public get pageableInfo(): boolean {
        return this.pageable.info as boolean;
    }


    public get pageablePreviousNext(): boolean {
        return this.pageable.previousNext as boolean;
    }

    public get gridSettingsScrollable(): ScrollMode {
        return this.gridSettings.scrollable as ScrollMode;
    }

    public get stateFilter(): CompositeFilterDescriptor {
        return this.state.filter as CompositeFilterDescriptor;
    }

    public filterType1(filter: string): 'boolean' | 'numeric' | 'text' | 'date' {
        return filter as 'boolean' | 'numeric' | 'text' | 'date';
    }

    public saveJson(): void {
      // Check if filters are removed and adjust the data accordingly
      const isUnfiltered = this.areFiltersRemoved(this.state.filter);

      // If filters are removed, get all the data
      let dataToExport;
      if (isUnfiltered) {
        dataToExport = this.dashboardData.notificationData; // Assuming this contains all your data
      } else {
        // Otherwise, only export the current page's data
        dataToExport = this.applyState(this.dashboardData.notificationData);
      }

      // Convert the data to JSON and encode it for download
      const dataURI = 'data:text/json;base64,' + encodeBase64(JSON.stringify(dataToExport));
      saveAs(dataURI, this.gridSettings.exportFileName + '.json');
    }

    public saveExcel(): ExcelExportData | Observable<ExcelExportData> {
        return this.getExcelData();
    }

    public getExcelData(): ExcelExportData {
        const isUnfiltered = this.areFiltersRemoved(this.state.filter);
        let gridXlData: any[];
        if (isUnfiltered) {
          gridXlData = this.dashboardData.notificationData;
        } else {
          // Otherwise, only export the current page's data
          gridXlData = this.applyState(this.dashboardData.notificationData);
        }
        return {
            data: gridXlData
        };
    }

    private applyState(data: any[]): any[] {
      // Update the state with the current grid filters
      const filteredData = process(data, { filter: this.state.filter }).data;

      // If the filtered data length is less than state.take, update state.take to match the filtered data length
      this.state.take = filteredData.length;

      // Process the data based on the updated state
      return process(filteredData, this.state).data;
    }

  previousFilterState: CompositeFilterDescriptor | null = null;

  onFilterChange(event: CompositeFilterDescriptor): void {
    // Determine if the filters have been removed
    const filtersRemoved = this.areFiltersRemoved(event);

    // Log for debugging
    // console.log('Filter Change Event:', event);
    // console.log('Previous Filter State:', this.previousFilterState);
    // console.log('Filters Removed:', filtersRemoved);

    // Update the previous filter state
    this.previousFilterState = event;

    // Update the state with the current filters
    this.state.filter = event;

    if (filtersRemoved) {
      // If filters are removed, reset take, skip, and any other state you need
      this.state.take = this.gridSettings.pageSize; // Reset take to default
      this.state.skip = 0;   // Reset skip to start from the first page
      this.gridData = of(this.dashboardData.notificationData); // Reset grid data to show all items

      // Optionally, trigger any additional actions here
      this.onFiltersRemoved();
    } else {
      // Adjust state.take based on the filtered data count
      const filteredData = process(this.dashboardData.notificationData, { filter: this.state.filter }).data;
      this.state.take = filteredData.length < this.state.take ? filteredData.length : this.state.take;
      this.gridData = of(this.applyState(this.dashboardData.notificationData));
    }
  }

  onFiltersRemoved(): void {
    // Perform any additional actions needed after filters are removed
    //console.log('Filters were removed. Grid state has been reset.');
    this.cd.detectChanges(); // Optionally, trigger change detection if needed
  }

// Helper method to determine if filters have been removed
  private areFiltersRemoved(filter: CompositeFilterDescriptor): boolean {
    if (!filter || !filter.filters || filter.filters.length === 0) {
      return true;
    }

    // Check if all filters are empty
    return filter.filters.every(f => {
      if (this.isCompositeFilter(f)) {
        return this.areFiltersRemoved(f);
      } else {
        return f.value === null || f.value === undefined || f.value === '';
      }
    });
  }

// Helper method to check if a filter is a CompositeFilterDescriptor
  private isCompositeFilter(filter: FilterDescriptor | CompositeFilterDescriptor): filter is CompositeFilterDescriptor {
    return (filter as CompositeFilterDescriptor).filters !== undefined;
  }



  //Hides the column from the grid for the specified field
    public hideColumn(field: string): void {
      let index = this.hiddenColumns.indexOf(field);
      if (index !== -1) {
        // Remove the column from our hidden fields
        this.hiddenColumns.splice(index, 1);
      } else {
        // Add the column to our hidden fields
        this.hiddenColumns.push(field);
      }
      // Update the visibility status of the "Select All" checkbox
      this.allColumnsVisible = this.hiddenColumns.length === 0;
      localStorage.setItem(`${this.gridDataUrl}HiddenColumns`, JSON.stringify(this.hiddenColumns));
    }

    public toggleAllColumnsVisibility(): void {
      this.allColumnsVisible = !this.allColumnsVisible; // Toggle the visibility state
      if (this.allColumnsVisible) {
        // If true, no columns should be hidden
        this.hiddenColumns = [];
      } else {
        // If false, all columns should be hidden
        this.hiddenColumns = this.gridSettings.columnSettings.map(column => column.field);
      }
      localStorage.setItem(`${this.gridDataUrl}HiddenColumns`, JSON.stringify(this.hiddenColumns));
    }

    //Close the open dropdowns
    public closeAllMenus() {
        this.isFieldsOpen = false;
        this.isExportOpen = false;
    }


    //Hide All the column from the grid
    public showAllColumns(): void {
        this.hiddenColumns = [];
        //localStorage.setItem(`${this.gridDataUrl}HiddenColumns`, JSON.stringify(this.hiddenColumns));
        this.isCheckboxDisabled = true;
    }

    // enable/disable auto refresh every 15 min
    public updateAutoRefreshMode(mode: boolean) {
        if (mode === true) {
            this._msgService.setMessages(this.autoRefreshOnMessage);
            // refresh grid every 15 min
            this.refreshIntervalId = setInterval(() => {
                this.refreshData();
            }, (15 * 60000));
        } else {
            if (this.refreshIntervalId) {
                this._msgService.setMessages(this.autoRefreshOffMessage);
                clearInterval(this.refreshIntervalId);
            }
        }
    }

    public categoryDisplayVal(args: any) {
        //  console.log("Label val: " + args);
        return (args.value && args.value.length > 20) ? args.value.substring(0, 20) + "..." : args.value;
    }
 
  /**
* Below method converts a given date string to the user's local time zone.
* 
* @param {string} dateString - The date string to be converted.
* @returns {localDate : string} - The date string converted to the user's local time zone in "YYYY-MM-DD HH:mm" format.
*/
  convertToUserTimeZone(dateString: string): string {
    // Parse the date string and convert it to UTC
    const utcDate = moment.utc(dateString);

    // Get the user's time zone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Convert the UTC date to the user's local time zone in "YYYY-MM-DD HH:mm" format
    const localDate = utcDate.tz(userTimeZone).format('YYYY-MM-DD HH:mm');

    return localDate;
  }

}

